<template>
  <div class="input">
    <Input
      ref="input"
      :type="type"
      :placeholder="placeholder"
      v-model="data"
      :password="type === 'password' ? true : false"
      autocomplete="off"
      :disabled="disabled"
      :maxlength="maxlength"
      @on-blur="blur"
      @on-change="keyup"
    />
  </div>
</template>

<script>
import Schema from 'async-validator';
export default {
  name: 'AuthFormInputText',
  props: {
    type: {
      type: String,
      default: 'text',
    },
    maxlength: Number,
    placeholder: {
      type: String,
    },
    rule: {
      type: [Object, Array],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: [String, Number],
  },
  data() {
    return {
      data: '',
      validator: null,
    };
  },
  watch: {
    value(n, o) {
      const newVal = JSON.stringify(n);
      const oldVal = JSON.stringify(o);
      if (newVal === oldVal) return;
      this.data = n;
    },
  },
  methods: {
    check() {
      return new Promise((resolve, reject) => {
        this.validate().then(() => {
          this.$emit('validator', true);
          resolve(true);
        }, (msg) => {
          this.$emit('validator', msg);
          resolve(false);
        });
      });
    },
    validate() {
      return new Promise((resolve, reject) => {
        new Schema({
          value: this.rule,
        }).validate({value: this.data}, (err) => {
          if (err) {
            reject(err[0].message);
          } else {
            resolve();
          }
        });
      });
    },
    keyup() {
      this.$emit('input', this.data);
    },
    blur() {
      this.validate().then(() => {
        this.$emit('validator', true);
      }, (msg) => {
        this.$emit('validator', msg);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  input {
    color: rgba(0,0,0,.45);
  }
</style>
